import { createAsyncTypes } from 'utils/ActionCreator'

const INTEGRATION_NAMESPACE = 'EmailEncryption/Integration'

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', INTEGRATION_NAMESPACE)
export const FETCH_CONFIG_ASYNC = createAsyncTypes('FETCH_CONFIG', INTEGRATION_NAMESPACE)
export const VALIDATE_CONNECTION_ASYNC = createAsyncTypes(
  'VALIDATE_CONNECTION',
  INTEGRATION_NAMESPACE
)
export const ACTIVATE_CONFIG_ASYNC = createAsyncTypes('ACTIVATE_CONFIG', INTEGRATION_NAMESPACE)
export const UPDATE_CONFIG_ASYNC = createAsyncTypes('UPDATE_CONFIG', INTEGRATION_NAMESPACE)
export const FETCH_LICENSED_DOMAINS_ASYNC = createAsyncTypes(
  'FETCH_LICENSED_DOMAINS',
  INTEGRATION_NAMESPACE
)
